import React from 'react';
import PropTypes from 'prop-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { graphql } from 'gatsby';
import { BLOCKS } from '@contentful/rich-text-types';
import classNames from 'classnames';
import RichTextKahoot from './rich-text-kahoot';
import RichTextMedia from './rich-text-media';
import * as Styles from './rich-text.module.scss';
import Heading from './heading';

export function defaultRichTextOptions(headingLevel, imageClassName) {
  return {
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => {
        return <Heading level={headingLevel}>{children}</Heading>;
      },
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        const {data} = node;

        // Temporary development notes for Kahoot addition
        // Contentful data strctures updated on the "stage" environment
        // 1. Created new ContentfulKahoot content type
        // 2. Create a ___PLACEHOLDER___DO NOT DELETE stub in ContentfuKahoot
        // 3. Added "Kahoot" to the allowed embedded block entry on the body field of the article content type
        // 4. Updated body field on article __PLACEHOLDER__DO NOT DELETE stub to embed __PLACEHOLDER__DO NOT DELETE kahoot
        // See /articles/doctors-improving-inclusion for placeholder embed of Kahoot

        if (data.target) {
          if (data.target.internal.type === "ContentfulKahoot") {
            return <RichTextKahoot kahootId={data.target.kahootId}/>
          }

          if (data.target.internal.type === "ContentfulMedia") {
            return (
              <RichTextMedia
                image={data.target}
                description={data.target.description}
                title={data.target.title}
                source={data.target.source}
                className={imageClassName}
              />
            );
          }
        }

        return null;
      },
    },
  };
}

function RichText({body, headingLevel, className, richTextOptions, imageClassName}) {
  const emptyParagraphFix = (copy) => {
    const lastElement = copy[copy.length - 1];

    if (
      lastElement.type === 'p' &&
      lastElement.props.children.length === 1 &&
      (lastElement.props.children[0] === '\n\n\n' || lastElement.props.children[0] === '')
    ) {
      copy.pop();
    }

    return copy;
  };

  return (
    <div className={classNames(Styles.root, className)}>
      {emptyParagraphFix(renderRichText(body, richTextOptions(headingLevel, imageClassName)))}
    </div>
  );
}

RichText.propTypes = {
  body: PropTypes.shape({}).isRequired,
  headingLevel: PropTypes.number,
  className: PropTypes.string,
  richTextOptions: PropTypes.func,
  imageClassName: PropTypes.string,
};

RichText.defaultProps = {
  headingLevel: 1,
  className: null,
  richTextOptions: defaultRichTextOptions,
  imageClassName: null,
};

export const query = graphql`
  fragment RichTextFields on ContentfulArticle {
    body {
      raw
      references {
        ...RichTextMediaFields
        ...RichTextKahootFields
      }
    }
  }
`;

export default RichText;
